import React, { PureComponent } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import * as R from 'ramda'
import SingleChoice from './questionTypes/SingleChoice'
import MultiChoice from './questionTypes/MultiChoice'
import Grid from './questionTypes/Grid'
import Numeric from './questionTypes/Numeric'
import DropdownList from './questionTypes/DropdownList'
import Percentage from './questionTypes/Percentage'
import Priority from './questionTypes/PriorityClick'
import TextInput from './questionTypes/TextInput'
import StaticText from './questionTypes/StaticText'
import UrlVariable from './questionTypes/Urlvariable'
import TextBoxList from './questionTypes/TextBoxList'
import DateQuestion from './questionTypes/Date'
import FormQuestion from './questionTypes/Form'
import NumberForm from './questionTypes/NumberForm'
import NPS from './questionTypes/NPS'
import { parseHtmlForReact, stripOutHtml } from './helpers'
//import '../assets/css/question.css'

@observer
class Question extends PureComponent {
    getText = (code, textOnly) => {
        const { question, store } = this.props
        const { langcode } = store
        const { defaultLocale } = store.data.metadata
        const { initialLocale } = question

        const valueMap = {
            // shortTitle: '',
            D: 'longTitle',
            I: 'instructions',
            A: 'aboveText',
            B: 'belowText',
            // content: ''
        }

        let text = ''
        const contentKey = valueMap[code]
        if (question.content[contentKey]) {
            if (question.content[contentKey][langcode]) {
                ({ text } = question.content[contentKey][langcode])
            } else if (question.content[contentKey][defaultLocale]) {
                ({ text } = question.content[contentKey][defaultLocale])
            } else if (question.content[contentKey][initialLocale]) {
                ({ text } = question.content[contentKey][initialLocale])
            }
        }

        const hasText = text && text.length
        if (code === 'A') {
            console.log(`Above ${text} -> ${store.replaceOptionMerge(text)}`)
        }
        text = store.replaceOptionMerge(text)
        let elem = null
        if (textOnly) {
            elem = hasText ? <p>{parseHtmlForReact(text)}</p> : <p></p>
        } else {
            elem = hasText ? <p>{parseHtmlForReact(text)}</p> : null
        }
        return elem
    }

    getTitle = () => {
        const { question, store } = this.props
        const { langcode } = store
        const hasText = question.content.longTitle
            && question.content.longTitle[langcode]
            && question.content.longTitle[langcode].text.length
        // console.log(question.content.longTitle[langcode].text)
        // console.log(parseHtmlForReact(question.content.longTitle[langcode].text))
        return hasText ? question.content.longTitle[langcode].text : ''
    }

    questionGetTitle = (question) => {
        const { store } = this.props
        const { langcode } = store
        const hasText = question.content.longTitle
            && question.content.longTitle[langcode]
            && question.content.longTitle[langcode].text.length
        // console.log(question.content.longTitle[langcode].text)
        // console.log(parseHtmlForReact(question.content.longTitle[langcode].text))
        return hasText ? question.content.longTitle[langcode].text : ''
    }

    getInheritance = () => {
        const { question, store } = this.props
        const { defaultLocale } = store.data.metadata
        const { langcode } = store
        const { parentId } = question
        if (!parentId) {
            return
        }
        const questionMap = store.data.pages.reduce((map, page) => {
            let questionMap = {}
            if (page.questions) {
                questionMap = page.questions.reduce((qMap, question) => {
                    qMap[question.id] = question
                    return qMap
                }, {})
            }
            return Object.assign(map, questionMap)
        }, {})
        const parentQuestion = questionMap[parentId]
        const shortTitle = parentQuestion.content.shortTitle
            ? parentQuestion.content.shortTitle[langcode]
                ? parentQuestion.content.shortTitle[langcode].text
                : parentQuestion.content.shortTitle[defaultLocale]
                    ? parentQuestion.content.shortTitle[defaultLocale].text : ''
            : ''
        return <div className='printInherit'><span>INHERITING</span>  Inherits From Question ({stripOutHtml(shortTitle)})</div>
    }

    getSkipLogic = () => {
        const { question, store } = this.props
        const { langcode } = store
        const { defaultLocale } = store.data.metadata
        const { initialLocale } = question
        const questionMap = store.data.pages.reduce((map, page) => {
            let questionMap = {}
            if (page.questions) {
                questionMap = page.questions.reduce((qMap, question) => {
                    qMap[question.id] = question
                    return qMap
                }, {})
            }
            return Object.assign(map, questionMap)
        }, {})
        const showIfLogics = store.data.skipLogic.filter(skiplogic => (skiplogic.action.kind === 'ShowQuestion' && skiplogic.action.pageQuestionId === question.id))
        const logic = showIfLogics.reduce((str, showIfLogic) => showIfLogic.triggerGroups.reduce((str, triggerGroup) => {
            const { interGroupLogicalOperator: additionalSkipLogicOperatorGroup } = triggerGroup
            const children = R.pathOr([], ['children'], triggerGroup).reduce((str, child) => {
                const { interGroupLogicalOperator: additionalSkipLogicOperatorChild } = child
                let logical = ''
                const triggers = child.triggers.reduce((str, trigger) => {
                    logical = trigger.interTriggerLogicalOperator
                    const { condition } = trigger
                    const { kind } = condition
                    const { interTriggerLogicalOperator } = trigger
                    const question = questionMap[condition.pageQuestionId]
                    const { isFlipped } = question.settings.frontend
                    const isMulti = ['RT', 'TB', 'SG'].indexOf(question.questionTypeCode) > -1
                    const isText = ['TA', 'TX'].includes(question.questionTypeCode)
                    let option
                    let option2

                    if (isMulti) {
                        const set1 = !isFlipped ? question.optionSetY : question.optionSetX
                        const set2 = !isFlipped ? question.optionSetX : question.optionSetY
                        option = set1.options.find(option => option.id === condition.set1)
                        if (condition.set2) {
                            option2 = set2.options.find(option => option.id === condition.set2)
                        }
                    } else if (isText) {
                        if (!str) {
                            const operator = kind === 'QuestionExistsInSurveyResponse'
                                ? 'is answered'
                                : this.readableOperatorText(interTriggerLogicalOperator)
                            str = `Question '${stripOutHtml(this.questionGetTitle(question))}' ${operator}`
                        } else {
                            str += `,'${equals}'`
                        }

                        return str
                    } else {
                        option = question.optionSet.options.find(option => option.id === condition.set1)
                    }

                    let equals
                    let option1Text = ''
                    if (option) {
                        if (option.langs[langcode]) {
                            option1Text = option.langs[langcode].text
                        } else if (option.langs[defaultLocale]) {
                            option1Text = option.langs[defaultLocale].text
                        } else if (option.langs[initialLocale]) {
                            option1Text = option.langs[initialLocale].text
                        }
                    }

                    let option2Text = ''
                    if (option2) {
                        if (option2.langs[langcode]) {
                            option2Text = option2.langs[langcode].text
                        } else if (option.langs[defaultLocale]) {
                            option2Text = option2.langs[defaultLocale].text
                        } else if (option.langs[initialLocale]) {
                            option2Text = option2.langs[initialLocale].text
                        }
                    }
                    if (!question.settings.frontend.isFlipped) {
                        equals = (option ? option1Text : '') + (option2 ? `_${option2Text}` : '')
                    } else {
                        equals = (option2 ? `${option2Text}_` : '') + (option ? option1Text : '')
                    }
                    if (!str) {
                        str = `Question '${stripOutHtml(this.questionGetTitle(question))}' ${this.readableOperatorText(interTriggerLogicalOperator)} ('${equals}'`
                    } else {
                        str += `,'${equals}'`
                    }

                    return str
                }, '')
                if (str) {
                    str += ` <b>${additionalSkipLogicOperatorChild}</b> `
                }
                str += `${triggers})`
                return str
            }, '')
            if (str) {
                str += ` <b>${additionalSkipLogicOperatorGroup}</b> `
            }
            str += `<b>(</b>${children}<b>)</b>`
            return str
        }, ''), '')
        return logic.length > 0 ? <div className='printShowIf'><span>SHOWIF</span> Hidden unless: {parseHtmlForReact(logic, false)}</div> : null
    }

    readableOperatorText = (operator) => {
        switch (operator) {
            case 'AND':
                return i18n.t('print.operator.AND')
            case 'NAND':
                return i18n.t('print.operator.NAND')
            case 'OR':
                return i18n.t('print.operator.OR')
            case 'NOR':
                return i18n.t('print.operator.NOR')
            default:
                return ''
        }
    }

    getCustomClasses = () => {
        const { question } = this.props

        let customClasses = ''

        if (question.questionTypeCode === 'NF') {
            customClasses = R.pathOr('', ['settings', 'classNames'], question)
        } else if (question.questionTypeCode !== 'FM') {
            customClasses = R.pathOr('', ['settings', 'frontend', 'classNames'], question)
        }

        return customClasses
    }

    render() {
        const {
            question,
            store,
            printMode,
            goToNextQuestion,
        } = this.props
        const questionType = question.questionTypeCode
        console.log('render question ', questionType, store.questionLogicUpdated[question.id])
        let element
        switch (questionType) {
            case 'RD':
                element = <SingleChoice
                    goToNextQuestion={goToNextQuestion}
                    questionLogicUpdated={store.questionLogicUpdated[question.id]}
                />
                break
            case 'CH':
                element = <MultiChoice
                    questionLogicUpdated={store.questionLogicUpdated[question.id]}
                />
                break
            case 'SB':
                element = <DropdownList langCode={store.langcode}/>
                break
            case 'TB':
            case 'SG':
            case 'RT':
                element = <Grid
                    goToNextQuestion={goToNextQuestion}
                    questionLogicUpdated={store.questionLogicUpdated[question.id]}
                />
                break
            case 'I':
                element = <Numeric />
                break
            case 'PC':
                element = <Percentage
                    questionLogicUpdated={store.questionLogicUpdated[question.id]}
                />
                break
            case 'OD':
                element = <Priority
                    questionLogicUpdated={store.questionLogicUpdated[question.id]}
                    key={question.id}
                />
                break
            case 'TX':
            case 'TA':
                element = <TextInput />
                break
            case 'ST':
                element = <StaticText />
                break
            case 'UV':
                element = <UrlVariable/>
                break
            case 'TL':
                element = <TextBoxList
                    questionLogicUpdated={store.questionLogicUpdated[question.id]}
                />
                break
            case 'DT':
                element = <DateQuestion
                    questionLogicUpdated={store.questionLogicUpdated[question.id]}
                />
                break
            case 'FM':
                element = <FormQuestion
                    questionLogicUpdated={store.questionLogicUpdated[question.id]}
                />
                break
            case 'NF':
                element = <NumberForm
                    questionLogicUpdated={store.questionLogicUpdated[question.id]}
                />
                break
            default:
                element = null
        }
        if (
            question.nps
            || (
                question.settings
                && question.settings.frontend
                && question.settings.frontend.renderNPS
            )
        ) {
            element = <NPS />
        }

        const skipLogic = store.printMode ? this.getSkipLogic() : ''
        const inheritance = store.printMode ? this.getInheritance() : ''
        /**
         * using cloneElement to add additonal
         * props to component assigned to `element`
         */
        element = React.cloneElement(element, {
            index: this.props.index,
            question,
            store,
            printMode: store.printMode,
        })
        const validationMsg = question.hasOwnProperty('validator')
                && question.validator.error
                && !Object.values(question.validator.otherValidation).some(validation => validation.error)
            ? <span className="validationError radius"><i className="fal fa-exclamation-triangle"></i>{question.validator.message}</span>
            : null
        const additionalClass = (questionType !== 'UV' || printMode) ? '' : 'UVContainer'
        const validationContent = !['ST', 'UV'].includes(questionType) ? <div className="validationContainer">{validationMsg}</div> : null
        const instrContent = this.getText('I')
        const questionContent = !['ST', 'UV'].includes(questionType) ? <h3>{this.getText('D')}</h3> : null
        const aboveText = this.getText('A') // question.hasOwnProperty("aboveText") && question.aboveText[langcode].length ? <div className="aboveText">{parseHtmlForReact(question.aboveText[langcode])}</div> : null
        const belowText = this.getText('B') // question.hasOwnProperty("belowText") && question.belowText[langcode].length ? <div className="belowText">{parseHtmlForReact(question.belowText[langcode])}</div> : null

        return (
            <div data-id={question.id} className={`questioncontainer ${additionalClass} ${this.getCustomClasses()}`}>
                {aboveText}
                {questionContent}
                {skipLogic}
                {inheritance}
                {instrContent}
                {validationContent}
                <div className="questionbody">
                    {element}
                </div>
                {belowText}
            </div>
        )
    }
}

export default Question
